import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { FooterCopyrightComponent } from '../footer-copyright/footer-copyright.component';
import { IconComponent } from '../icon/icon.component';
import { LogoComponent } from '../logo/logo.component';

@Component({
  selector: 'ps-page-not-found',
  standalone: true,
  imports: [
    LogoComponent,
    ButtonComponent,
    IconComponent,
    FooterCopyrightComponent,
  ],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  public readonly homeRequested = output<void>();

  protected onHome(): void {
    this.homeRequested.emit();
  }
}
